import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

interface Props {
  text: string;
  onClick?: () => void;
  icon: React.ReactNode;
  isActive?: boolean;
  borderRightWidth?: number | string;
  py?: number | string;
  my?: number | string;
}

function SideNavButton({ text, onClick, my, icon, isActive, ...props }: Props) {
  return (
    <Flex
      as="a"
      align="center"
      userSelect="none"
      color={isActive ? "blue.500" : "gray.500"}
      cursor="pointer"
      onClick={onClick}
      fontSize="18px"
      _hover={{
        color: "blue.500",
      }}
      // _active={{
      //   bg: "primary.200",
      // }}
      transition="all .3s ease"
      borderRightColor="blue.500"
      borderRightWidth={isActive ? "2px" : 0}
      py={4}
      my={my}
      isTruncated
      {...props}>
      <Box my="auto" fontSize="xl" mr={2}>
        {icon}
      </Box>
      <Text fontWeight="700" isTruncated>
        {text}
      </Text>
    </Flex>
  );
}

SideNavButton.defaultProps = {
  isActive: false,
};

export default SideNavButton;
